export const SET_LOADING = 'SET_LOADING';
export const SET_PAGE = 'SET_PAGE';
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_DIRECTION = 'SET_DIRECTION';
export const LOGGED_IN = 'LOGGED_IN';
export const SET_BACKDROP = 'SET_BACKDROP';
export const SET_PASSWORD_MODAL = 'SET_PASSWORD_MODAL';
export const RESET = 'RESET';
